module.exports = __webpack_public_path__ + "img/ИФ-1(А)-015.27d6b39a.png";